import * as yup from 'yup';

const re = /^0\d{10,16}$/;

export default function nullableMobile(label) {
  return yup
    .string()
    .test(
      'Referrer Mobile',
      'This information is required. Please enter a valid mobile',
      (value) => {
        const valueClean = value ? value.replace(/\s/g, '') : null;
        if (re.test(valueClean)) {
          return true;
        } else if (valueClean === null) {
          return true;
        } else {
          return false;
        }
      },
    )
    .label()
    .nullable(label)
    .typeError(label);
}
